import { render, staticRenderFns } from "./StorageDashboard.vue?vue&type=template&id=3ddef449&scoped=true"
import script from "./StorageDashboard.vue?vue&type=script&lang=js"
export * from "./StorageDashboard.vue?vue&type=script&lang=js"
import style0 from "./StorageDashboard.vue?vue&type=style&index=0&id=3ddef449&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddef449",
  null
  
)

export default component.exports